// extracted by mini-css-extract-plugin
module.exports = {"hrWrap":"homeNewsList-module--hrWrap--1guPU","hr":"homeNewsList-module--hr--LGxvB"};